/* hero-banners.js (FADE MODE + SWIPE)
  - arrows, dots, autoplay, interval, hover/focus pause
  - slide transition: fade (opacity via .is-active)
  - + Mobile swipe (pointer drag)
*/
(function () {
  const SEL = {
    slider: '[data-hb-slider]',
    track: '[data-hb-track]',
    slide: '[data-hb-slide]',
    prev: '[data-hb-prev]',
    next: '[data-hb-next]',
    dots: '[data-hb-dots]',
  };

  const prefersReducedMotion = (() => {
    try {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  })();

  function clampInterval(val) {
    const n = parseInt(val || '4000', 10);
    if (!Number.isFinite(n)) return 4000;
    return Math.min(7000, Math.max(2000, n));
  }

  function isInteractive(el) {
    if (!el) return false;
    return !!el.closest('a, button, input, textarea, select, [role="button"], [data-no-swipe]');
  }

  function initSlider(root) {
    const slider = root.querySelector(SEL.slider);
    if (!slider) return;

    const track = slider.querySelector(SEL.track);
    if (!track) return;

    const slides = Array.from(slider.querySelectorAll(SEL.slide));
    const len = slides.length;
    if (len <= 0) return;

    const prevBtn = slider.querySelector(SEL.prev);
    const nextBtn = slider.querySelector(SEL.next);
    const dotsWrap = slider.querySelector(SEL.dots);

    let index = 0;
    let timer = 0;
    let isPaused = false;
    let isVisible = true;
    let isPageVisible = !document.hidden;

    const autoplayAttr = slider.getAttribute('data-autoplay') === 'true';
    const interval = clampInterval(slider.getAttribute('data-interval'));
    const autoplay = autoplayAttr && !prefersReducedMotion && len > 1;

    let dots = null;

    function setActive(i) {
      for (let n = 0; n < len; n++) {
        slides[n].classList.toggle('is-active', n === i);
      }
      if (dots) {
        for (let n = 0; n < dots.length; n++) {
          dots[n].setAttribute('aria-current', n === i ? 'true' : 'false');
        }
      }
    }

    function go(i) {
      index = (i + len) % len;
      setActive(index);
    }

    function stop() {
      if (timer) {
        clearTimeout(timer);
        timer = 0;
      }
    }

    function canRun() {
      return autoplay && !isPaused && isVisible && isPageVisible;
    }

    function schedule() {
      stop();
      if (!canRun()) return;
      timer = setTimeout(function tick() {
        go(index + 1);
        schedule();
      }, interval);
    }

    function restart() { schedule(); }
    function onPrev() { go(index - 1); restart(); }
    function onNext() { go(index + 1); restart(); }

    function pause() { isPaused = true; stop(); }
    function resume() { isPaused = false; schedule(); }

    // 단일 슬라이드일 때는 초기 활성화만 하고 종료 (리스너/옵저버 불필요)
    setActive(0);
    if (len === 1) return;

    // dots
    if (dotsWrap && len > 1) {
      dotsWrap.textContent = '';
      const frag = document.createDocumentFragment();
      const arr = new Array(len);

      for (let i = 0; i < len; i++) {
        const btn = document.createElement('button');
        btn.className = 'hb-dot';
        btn.type = 'button';
        btn.setAttribute('aria-label', `Go to slide ${i + 1}`);
        btn.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        btn.addEventListener('click', function () {
          go(i);
          restart();
        });
        arr[i] = btn;
        frag.appendChild(btn);
      }
      dotsWrap.appendChild(frag);
      dots = arr;
    }

    // arrows
    if (prevBtn) prevBtn.addEventListener('click', onPrev);
    if (nextBtn) nextBtn.addEventListener('click', onNext);

    // autoplay가 켜진 경우에만 pause/resume 리스너 등록
    if (autoplay) {
      slider.addEventListener('pointerenter', pause);
      slider.addEventListener('pointerleave', resume);
      slider.addEventListener('focusin', pause);
      slider.addEventListener('focusout', resume);
    }

    // -----------------------------
    // ✅ SWIPE (pointer drag)
    // -----------------------------
    let dragId = null;
    let startX = 0;
    let startY = 0;
    let dx = 0;
    let dy = 0;
    let dragging = false;
    let blockClick = false;

    const SWIPE_MIN = 28;        // 최소 이동
    const SWIPE_RATIO = 1.2;     // 가로가 세로보다 충분히 커야 swipe
    const CLICK_BLOCK_MS = 450;  // 드래그 후 링크 클릭 방지

    function onPointerDown(e) {
      if (len <= 1) return;
      if (!e.isPrimary) return;
      if (isInteractive(e.target)) return;

      dragId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      dx = 0;
      dy = 0;
      dragging = true;
      blockClick = false;

      pause(); // 드래그 중 자동재생 멈춤
      try { slider.setPointerCapture(dragId); } catch (_) {}
    }

    function onPointerMove(e) {
      if (!dragging || e.pointerId !== dragId) return;
      dx = e.clientX - startX;
      dy = e.clientY - startY;

      // 세로 스크롤이 우세하면 스와이프 판단 안함
      if (Math.abs(dy) > Math.abs(dx) * SWIPE_RATIO) return;

      // 여기서 preventDefault를 걸어줘야 iOS에서 가로 스와이프가 안정적임
      // (단, passive면 안되므로 addEventListener 옵션에서 passive:false)
      e.preventDefault();
      if (Math.abs(dx) > 6) blockClick = true;
    }

    function endDrag(e) {
      if (!dragging || e.pointerId !== dragId) return;
      dragging = false;

      const absX = Math.abs(dx);
      const absY = Math.abs(dy);

      // 세로가 더 크면 무시 (스크롤)
      if (absY > absX * SWIPE_RATIO) {
        resume();
        return;
      }

      if (absX >= SWIPE_MIN) {
        if (dx < 0) onNext();
        else onPrev();
      } else {
        resume();
      }

      if (blockClick) {
        const until = Date.now() + CLICK_BLOCK_MS;
        const clickGuard = function (ev) {
          if (Date.now() <= until) {
            ev.preventDefault();
            ev.stopPropagation();
          }
          document.removeEventListener('click', clickGuard, true);
        };
        document.addEventListener('click', clickGuard, true);
      }

      try { slider.releasePointerCapture(dragId); } catch (_) {}
      dragId = null;
    }

    slider.addEventListener('pointerdown', onPointerDown);
    slider.addEventListener('pointermove', onPointerMove, { passive: false });
    slider.addEventListener('pointerup', endDrag);
    slider.addEventListener('pointercancel', endDrag);

    // autoplay가 켜진 경우에만 가시성/오프스크린 감지
    let io = null;
    const onVisibility = function () {
      isPageVisible = !document.hidden;
      if (!isPageVisible) stop();
      else schedule();
    };
    if (autoplay) {
      document.addEventListener('visibilitychange', onVisibility);

      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(
          (entries) => {
            const entry = entries && entries[0];
            isVisible = !!(entry && entry.isIntersecting);
            if (!isVisible) stop();
            else schedule();
          },
          { root: null, threshold: 0.15 }
        );
        io.observe(slider);
      }
    }

    // init
    schedule();

    // design mode cleanup
    if (window.Shopify && Shopify.designMode) {
      const onUnload = function (evt) {
        if (!evt || !evt.target) return;
        if (!root.contains(evt.target)) return;

        stop();
        if (autoplay) {
          document.removeEventListener('visibilitychange', onVisibility);
        }
        if (prevBtn) prevBtn.removeEventListener('click', onPrev);
        if (nextBtn) nextBtn.removeEventListener('click', onNext);
        if (autoplay) {
          slider.removeEventListener('pointerenter', pause);
          slider.removeEventListener('pointerleave', resume);
          slider.removeEventListener('focusin', pause);
          slider.removeEventListener('focusout', resume);
        }

        slider.removeEventListener('pointerdown', onPointerDown);
        slider.removeEventListener('pointermove', onPointerMove);
        slider.removeEventListener('pointerup', endDrag);
        slider.removeEventListener('pointercancel', endDrag);

        if (io) io.disconnect();
      };
      document.addEventListener('shopify:section:unload', onUnload);
    }
  }

  function initAll() {
    document.querySelectorAll('.hb').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
